import { render } from "./LoginPageNew.vue?vue&type=template&id=5ec0349c&scoped=true"
import script from "./LoginPageNew.vue?vue&type=script&lang=js"
export * from "./LoginPageNew.vue?vue&type=script&lang=js"

import "./LoginPageNew.vue?vue&type=style&index=0&id=5ec0349c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec0349c"]])

export default __exports__